// AXIOS SETUP
import axios from "axios"
import swal from 'sweetalert2'
import _ from 'lodash'
import { store } from "@/store/store-init"

const Toast = swal.mixin({
	toast: true,
	position: 'top-end',
	showConfirmButton: false,
	grow: 'column',
	timer: 3000
})

const prod = true;

let rootURI = (prod)? 'https://api.vps103788.mylogin.co/index.php?r=' : 'http://localhost:8001/refapp-api/index.php?r=';

axios.defaults.baseURL = rootURI + 'main';
axios.defaults.maediaImageRender = rootURI + 'img/render/';
axios.defaults.timeout = 30000

axios.interceptors.request.use( (config) => {
	// Do something before request is sent
	config.headers['Content-Type'] = 'text/plain';
	if(store.getters.authToken)
		config.headers['auth-token'] = store.getters.authToken;
	return config;
},  (error) =>  {
	// Do something with request error
	return Promise.reject(error);
});

// Add a response interceptor
axios.interceptors.response.use( (response) =>  {

	// Do something with response data
	let processing = response.data;

	if(!!processing.class && processing.class=='danger')
		processing.class = 'error';

	if(processing.msg){
		Toast.fire({
			type: ((processing.class) ? processing.class : 'info'),
			title: processing.msg
		});
	}
	return processing;
}, (error) => {
	Toast.fire({
		type: 'error',
		title: 'Error de servidor',
		text: error.message
	})
	return Promise.reject(error);
});

export {}